'use strict';

/* globals config, socket, app */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	'translator',
	'bootbox',
], function (Vue, translator, bootbox) {
	var internals = {};

	Vue.component('note', {
		props: ['noteData', 'removeFromBoard'],
		data: function () {
			return {
				editMode: false,
				note: this.noteData,
			};
		},
		mounted: function () {
			if (!this.note.noteId) {
				this.save();
			}
		},
		methods: {
			noteMouseUp: function () {
				var timeDiff = new Date() - this.noteMouseDownTime;

				if (timeDiff <= 150) {
					this.editMode = true;
				}
			},
			noteMouseDown: function () {
				this.noteMouseDownTime = new Date();
			},
			turnOffEditing: function () {
				this.editMode = false;
			},
			save: function () {
				var _this = this;
				internals.save(this.note, function (note) {
					_this.note.noteId = note.noteId;
					_this.note.commentsCount = 0;
				});
			},
			remove: function () {
				var _this = this;
				internals.removeDialog(this.note.noteId, function (noteId) {
					_this.removeFromBoard(noteId);
				});
			},
		},
		template: '<div :data-id="note.noteId" v-click-outside="turnOffEditing" :class="{ \'edit-mode\': editMode }" class="note" @mousedown="noteMouseDown" @mouseup="noteMouseUp" v-bind:style="{ left: note.x + \'px\', top: note.y + \'px\' }">' +
		'<header><input type="text" v-model="note.name" v-on:blur="save()" /><button v-on:click="remove()"><i class="fa fa-times" aria-hidden="true"></i></button></header>' +
		'<div class="note-content"><div :is="note.type" v-bind:note="note" v-bind:edit-mode="editMode" v-bind:save-note="save" v-on:save="save($event)"></div></div>' +
		'<div class="note-options-row">' +
		'<div class="options col-xs-6"><button class="btn btn-link move-btn"><i class="fa fa-arrows" aria-hidden="true"></i></button></div>' +
		'<div class="comments col-xs-6"><note-comments v-bind:note="note"></note-comments></div>' +
		'</div>' +
		'</div>',
	});

	internals.save = function (note, callback) {
		socket.emit('plugins.ideasBoard.saveNote', note, function (err, note) {
			if (err) {
				return app.alertError(err.message);
			}

			return callback(note);
		});
	};

	internals.removeDialog = function (noteId, removeCallback) {
		translator.translate('[[ideas-board:remove-note-confirm]]', function (translated) {
			bootbox.confirm(translated, function (confirm) {
				if (!confirm) {
					return;
				}

				socket.emit('plugins.ideasBoard.removeNote', noteId, function (err) {
					if (err) {
						return app.alertError(err.message);
					}

					return removeCallback(noteId);
				});
			});
		});
	};
});

